import { useParams } from 'react-router';

import { useEffect, useState } from 'react';

import { useGetPrototypesInfiniteQuery } from '@app-velocity/modules/scenarios';
import { useGetAppraisalsQuery } from '@app-velocity/modules/appraisals';

import { getPageAndFileData } from '../../../../core';

export const useWorkspaceView = () => {
  const [fileId, setFileId] = useState<string>();
  const [fileName, setFileName] = useState<string>();
  const { workspaceId, teamId } = useParams<{
    workspaceId: string;
    teamId: string;
  }>();

  const { data: challengesData, isLoading: areChallengesLoading } =
    useGetPrototypesInfiniteQuery(workspaceId, fileId, {
      size: 1,
      owner: 'own',
    });

  const { data: appraisals, isLoading: isLoadingAllAppraisals } =
    useGetAppraisalsQuery(workspaceId, fileId);

  const isLoading = areChallengesLoading || isLoadingAllAppraisals;
  const anyChallenges = (challengesData?.pages[0]?.totalElements ?? 0) > 0;
  const anyChallengesOrAppraisals =
    anyChallenges || (!!appraisals && appraisals.length > 0);

  const getFileId = async () => {
    const { fileId: readFileId, fileName: readFileName } =
      await getPageAndFileData();
    setFileId(readFileId);
    setFileName(readFileName);
  };

  useEffect(() => {
    getFileId();
  }, []);

  return {
    isLoading,
    anyChallenges,
    anyAppraisals: !!appraisals && appraisals.length > 0,
    anyChallengesOrAppraisals,
    fileId,
    fileName,
    workspaceId,
    teamId,
  };
};
